export const NAMESPACE = 'bigbite-viewslot-wordpress-plugin';

export const TABLES = {
  AD_VIEWS: 'ad_views',
  SUPABASE_AD_VIEWS: 'page_ad_views',
};

export const EVENT_TYPES = {
  SLOT_REQUESTED: 'slotRequested',
  SLOT_RENDER_ENDED: 'slotRenderEnded',
  IMPRESSION_VIEWABLE: 'impressionViewable',
};
